/// <amd-module name="Wit/Common/WitSettingsViews/Components/CriteriaTable/CriteriaSettingsView" />
import * as React from "react";
import { css, usePageContext } from "VSS/Platform/Layout";
import { Header, TitleSize } from "VSSUI/Header";
import * as Resources from "Wit/Common/WitSettingsViews/Resources";
import { TableStatus } from "../TableStatus";
import { ICriteriaService } from "./CriteriaService";
import { CriteriaTable } from "./CriteriaTable";

export interface CriteriaSettingsViewProps {
    /**
     * Optional class name
     */
    className?: string;
    /**
     * Team settings controls will be disabled
     */
    disabled?: boolean;
}

export const CriteriaSettingsView: React.FunctionComponent<CriteriaSettingsViewProps> = ({ className, disabled }) => {
    const pageContext = usePageContext();
    const criteriaSettingsService = pageContext.getService<ICriteriaService>("ICriteriaService");
    const rows = criteriaSettingsService.rows;
    const fieldsReady = criteriaSettingsService.fieldsReady;
    return (
        <div className={css("rhythm-vertical-8", className)}>
            <Header
                className="padding-vertical-0"
                description={Resources.FieldCriteriaDescription}
                title={Resources.FieldCriteriaHeader}
                titleSize={TitleSize.Small}
            />
            <TableStatus
                className="padding-horizontal-20"
                dataProviderErrorMessage={criteriaSettingsService.dataProviderErrorMessage}
                validationErrorMessage={criteriaSettingsService.validationErrorMessage}
            />
            <CriteriaTable
                disabled={disabled}
                fieldsReady={fieldsReady}
                onAddRow={() => criteriaSettingsService.addCriteriaSettingsRow()}
                onDeleteRow={(rowIndex, item) => criteriaSettingsService.removeCriteriaRow(rowIndex)}
                onUpdateField={(rowIndex, item, fieldReferenceName) => criteriaSettingsService.updateField(rowIndex, fieldReferenceName)}
                onUpdateOperator={(rowIndex, item, operator) => criteriaSettingsService.updateOperator(rowIndex, operator)}
                onUpdateValue={(rowIndex, item, fieldValue) => criteriaSettingsService.updateValue(rowIndex, fieldValue)}
                rows={rows}
            />
        </div>
    );
};
